module.exports = __webpack_public_path__ + "static/media/sign-out.5a2d1777.svg";